<template>
  <div>
    支付成功！<router-link to="/" style="color: #0ab5d5">点击返回首页</router-link>
  </div>
</template>

<script>
  export default {
    name: ""
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PaySuccess.vue